module.exports = ".form-horizontal .control-label {\n  \n    padding-top: 5px;\n}"